<script setup lang="ts">
import type { SubmitEventPromise } from 'vuetify';

import { reactive, ref } from 'vue';

import KSingleAutocompleteField from '@/components/fields/KSingleAutocompleteField.vue';
import useForm from '@/composables/useForm';
import { requiredValidationRule } from '@/helpers/validationRules';
import { splitToBaseItems } from '@/constants/fieldItems';

export interface InitialData {
  warehouse?: string;
}

export interface ValidData {
  warehouse: string;
}

export interface Props {
  loading?: boolean;
  initialData?: InitialData;
}
const props = withDefaults(defineProps<Props>(), {
  loading: false,
  initialData: () => ({}),
});
const emit = defineEmits<{
  submit: [event: SubmitEventPromise | null | undefined, formData: ValidData];
}>();

const formData = reactive<InitialData>({});
const isValid = ref(true);

const { form, handleSubmit } = useForm(props, formData, function (event) {
  if (formData.warehouse == null) return;
  const validData: ValidData = {
    warehouse: formData.warehouse,
  };
  emit('submit', event, validData);
});
</script>

<template>
  <v-form
    ref="form"
    v-model="isValid"
    validate-on="lazy"
    :class="$style.splitToBaseDialogForm"
    data-testid="splitToBaseDialogForm"
    @submit.prevent="handleSubmit"
  >
    <KSingleAutocompleteField
      v-model="formData.warehouse"
      label="Warehouse"
      :disabled="props.loading"
      :rules="[requiredValidationRule]"
      :class="$style.field"
      :items="splitToBaseItems"
      @keydown.enter="handleSubmit"
    />
    <input type="submit" class="hidden" :disabled="props.loading" />
  </v-form>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/colors';
@use '@/styles/variables';

.splitToBaseDialogForm {
}
  .field {
  }
</style>
